export default {
    API_KEY: process.env.MIX_API_KEY,
    API_URL: process.env.MIX_API_URL,
    BUGSNAG_API_KEY: process.env.MIX_BUGSNAG_API_KEY,
    FIREBASE: {
        API_KEY: process.env.MIX_FIREBASE_API_KEY,
        DB_URL: process.env.MIX_FIREBASE_DATABASE_URL,
        MEASUREMENT_ID: process.env.MIX_FIREBASE_MEASUREMENT_ID,
        PROJECT_ID: process.env.MIX_FIREBASE_PROJECT_ID,
        APP_ID: process.env.MIX_FIREBASE_APP_ID,
    },
}
